module.exports = __webpack_public_path__ + "img/rosepetal-dep-cerealto-toro.b1e1b154.jpg";